import { chosen, languages, pick, t } from "../i18n";

// LanguageSwitch picks the language on pages before one has signed in; it
// is kept as the person's preference once they have.
export function LanguageSwitch() {
  return (
    <label className="language-switch">
      <span aria-hidden>🌐</span>
      <select value={chosen()} onChange={(e) => pick(e.target.value)} aria-label={t("Language")}>
        <option value="">{t("Automatic: your browser's language")}</option>
        {languages.map((l) => (
          <option key={l.id} value={l.id} lang={l.id}>
            {l.name}
          </option>
        ))}
      </select>
    </label>
  );
}
